module.exports = {
  messages: {
    login: {
      metaTitle: 'User Login - Access Your ASOGrow Account | ASOGrow',
      metaKeywords: 'User Login, Account Access',
      metaDesc: 'Log in to ASOGrow to access fully automated ASO optimization services and efficiently manage your app’s optimization projects and promotion data with ease.',
      signUpBtn: 'Sign Up',
      loginText: 'Login',
      email: 'Email',
      phone: 'Phone',
      emailInput: 'Please enter your email',
      password: 'Password',
      passInput: 'Password must contain at least 6 characters',
      forgetPassword: 'Forget Password?',
      invalidErr: 'Invalid email or password!',
      emptyErr: 'Can\'t be empty!',
      formatErr: 'Please enter the correct email',
      registerSuccess: 'Registered successfully',
      tip1: 'The phone number was used for the first time on the platform.',
      tip2: 'You have successfully registered a new account',
      next: 'Next',
      ninfo: 'No notifications',
      send: 'Send',
      resend: 'Resend',
    },
    gLogin: {
      loginText: 'Welcome to ASOGrow',
      contact: 'Contact Information',
      contactErr: 'Please enter your contact information.',
      link: 'Product Link (in Google Play)',
      linkEmpErr: 'Please enter your product link. ',
      linkErr: 'Please enter correct product link of Google Play.',
      urlErr: 'URL Format Error.',
      linkInput: 'Paste your application store url',
      loginBtn: 'Get Promotion Plan',
      login: 'Sign in with Google',
      register: 'Sign up with Google',
      text: 'or',
      nofind: 'App is not found in store',
      logBtnText: 'Sign in with Google',
      regBtnText: 'Sign up with Google',
      contactTip:
        'Make sure you fill in the correct contact, admin will contact you to send bonus coupons.',
      jump: 'Skip',
      warnTitle: 'Hello, my friend!',
      warnContent:
        'Contact us if you are interested in how to promote your app and start gaining users!',
      contactTip2: 'Recommend to contact us on WhatsApp!',
    },
    register: {
      metaTitle: 'Sign Up - Join ASOGrow Platform | ASOGrow',
      metaKeywords: 'User Registration, Account Creation, ASO Services, App Promotion',
      metaDesc: 'Easily create your ASOGrow account to start your app optimization and promotion journey, and enjoy professional, automated ASO services designed for growth.',
      name: 'Name',
      emailInput: 'Please enter your email',
      password: 'Password',
      passInput: 'Password must contain at least 6 characters',
      comPassword: 'Confirm password',
      comPassInput: 'Re-type Your Password',
      contact: 'Contact Information',
      code: 'Verification Code',
      codeInput: 'click the verification code image to refresh',
      tip1: 'I\'m over 18 years old',
      tip2: 'By signing up, you agree to ASOGrow\'s',
      tip22: 'Privacy Policy',
      tip222: ',',
      tip2222: 'Terms and Conditions',
      tip3: 'I agree to receive promo emails&newsletters from Youmi',
      btn: 'Sign Up',
      emptyErr: 'Can\'t be empty!',
      emailFormatErr: 'Please enter a correct email.',
      emailExit: 'Email Exists',
      nameErr: 'Only letters,numbers,spaces and chinese characters are allowed in Name.',
      passErr: 'Please enter password',
      passSameErr: 'Please enter the same password again',
      passRegErr: 'The password must be between 6-16 characters and include letters & numbers.',
      contactTip:
        'Make sure you fill in the correct contact, admin will contact you to send bonus coupons.',
      phoneFormatErr: 'Phone Number (Optional).',
      verificationCodeEmpty: 'Please enter verification code.',
      verificationCodeWrong: 'Verification code is wrong.',
      verificationCodeDigit: 'Please enter a 6-digit verification code.',
      verificationCodeSend: 'Timed out, please resend the verification code.',
      codeSended:
        'The verification code has been sent to your mobile phone, please check it carefully!',
      phoneRegistered: 'The phone number has been registered, please login directly!',
      regTip: 'Create New Account',
      codeAgain: 'Try again later',
      codeAgain2: 'SMS sent too frequently, please try again later',
      phoneTip: 'Your Phone Number',
      phoneExit: 'This mobile number has been registered',
      phoneErr1: 'Please enter numbers only',
      phoneErr2: 'Please enter the correct phone number',
      phoneErr3: 'Enter up to 20 digits',
      phoneTip2: 'Phone Number',
      contact2: 'Please enter contact information',
      andapp: 'Android APP',
      lastStep: 'Last Step: Fill in information',
      fullname: 'Please enter your full name',
      emaTip: 'Please enter your email to receive notices',
      appname: 'Please enter an app name / package',
      btnT: 'Explore Free ASO Journey',
    },
    registers: {
      title: 'Successfully Registered!',
      subtitle: 'Register Mailbox:',
      subtitle2: 'Register Phone:',
      content1: 'Please click on the activation link in the email.',
      content2: 'Make sure to check your',
      content22: 'spam',
      content222: 'folder.',
      btn: 'Go and Check',
      link: 'No email received?',
    },
    forget: {
      title: 'Retrieve Password',
      subTitle:
        'Please enter the signed up email and you will receive an email to reset your password.',
      email: 'Registered Account Email',
      emailInput: 'Please enter your email',
      code: 'Verification Code',
      confirm: 'Confirm',
      back: 'Back to login',
      codeErr: 'Please enter a correct verification code',
      emptyErr: 'Can\'t be empty!',
      noEmail: 'Email Not Exists',
      formatErr: 'Please enter the correct email',
    },
    forgets: {
      title: 'Check and Reset',
      subtitle: 'Check your email address:',
      content1:
        'We have sent you an email, please click the link in the email to reset a new password.',
      content2: 'If you can\'t find the mail, please check the spam.',
      btn: 'Check and Reset',
    },
    receive: {
      title: 'No Mail Received?',
      subtitle: 'Try the following solutions:',
      tip1: 'Please wait for a few minutes in case of network latency.',
      tip2: 'Don\'t forget to check your',
      tip22: 'spam',
      tip222: 'folder.',
      tip3: 'Please double check your email address:',
      tip4: 'Click here',
      tip44: 'to send a new activation email.',
      tip5: 'Click the service button on the lower right to contact us.',
      btn: 'Back to login',
    },
    activate: {
      title: 'Activate your account',
      subtitle: 'Check your mailbox:',
      tip1: 'Please click on the activation link in the email.',
      tip2: 'Make sure to check your',
      tip22: 'spam',
      tip222: 'folder.',
      btn: 'Back to login',
      btn2: 'No Mail Received?',
    },
    tipError: {
      netErr: 'Network Error',
      codeErr: 'Please enter a correct verification code.',
      emailNotAct: 'Email is not activated',
      emailExit: 'Failed to create an account. A user already exists with this email address',
      loginErr: 'Invalid email or password',
      timeout: 'Time Out! Please try again',
      ageErr:
        'In order to become an advertiser, you must be at least 18 years old and acccept the Terms & Conditions of ASOGrow platform.',
      limitErr:
        'Each account can only reset the password once a day, please check the new password in your mailbox.',
      emailFail: 'Failed to send email, please contact customer service.',
      accountNotActive: 'Account not active',
      srvErr: 'Server Internal Error, please contact customer service.',
      postOnly: 'Unknown error, please contact customer service.',
      pswDiff: 'Password Doesn\'t Match',
      emailExists: 'This email is already registered, please use a new email to register.',
      emailNotExists: 'This email is not registered.',
      alreadyVerify: 'Unknown error, please contact customer service.',
      unVerifyErr: 'Unverify Error, please contact customer service.',
      emailCountLimit: 'Email Count Limit, please contact customer service.',
      phoneCodeErr: 'Incorrect verification code!',
      internalErr: 'Internal error, try again later or use email to register',
      phoneCodeFormatErr: 'phone format error',
      invalidCodeErr: 'invalid code!',
      sendErr1:"The following is the troubleshooting information that can be used to feed back to customer service to solve the problem.",
      sendErr2: "Refreshing doesn't fix this? Click the button, and contact customer service.",
      sendErr3: "Error Msg",
      sendErr4: "Contact Us",
      emptyErr: 'Vaule should not be empty.',
      emptyErr2: 'Review content cannot be empty.',
      capErr: 'For better results, the Daily Cap should not be less than 3.',
      limitErr2: 'Please input less than 200 letters',
      notNumErr: 'value is not a number',
      limitErr3: 'Please input less than 500 letters',
      limitErr4: 'Comments cannot include semicolons {;}.',
      limitErr5: 'The number of comments and daily cap must be same',
      limitErr6: 'The file size does not exceed 3MB.',
      limitErr7: 'Only one file can be uploaded',
      limitErr8: 'Uploaded files can only be in or .xls or .xlsx or .txt or .csv format.',
      limitErr9: 'File empty!',
      limitErr10: 'File type error！',
    },
    home: {
      tip0: 'Hi',
      tip1: 'Recharge Super Bonus',
      tip2: 'The maximum recharge discount is launching now.',
      tip3: 'View Details',
      tip4: 'Welcome to ASOGrow',
      tip5: '  Automatic App Store Optimization Platform',
      tip6: 'Products',
      tip7: 'My Apps',
      tip8: 'Click to quickly experience the task',
      tip9: 'Check your banlance change records.',
      tip10: 'Quickly start tasks after deposit',
      tip11: 'WhatsApp Us to Get Free Trail!!',
      tip13: '2.Where will your ad appear?',
      tip14: '3.What is Keyword Search Campaign?',
      tip15: '4.What is App Rank for Keyword?',
      tip16: '5.What is Ratings and Reviews Campaign?',
      tip17: '6.How do we calculate the price?',
      tip18: 'Add App',
      tip19: 'Paste your application store url',
      tip20: 'Please enter the correct store url.',
      tip21: "Get Your App's Promotion Plan",
      tip22: 'If your app has achieved all goal levels,you can focus on keyword search ranking optimization.',
      tip23: 'contact our account manager ',
      tip24: 'Running Campaigns',
      tip25: 'Statistics',
      tip26: 'Promotion Plan',
      tip27: 'Publisher',
      tip28: 'Category',
      tip29: 'Installs',
      tip30: 'Reviews',
      tip31: 'Ratings',
      tip32: 'Achieved:',
      tip33: 'Get more organic users',
      tip34: 'Get more good reviews',
      tip35: 'Improve your ratings',
      tip36: 'Lv3 Goal: ',
      tip37: 'Installs Goal Level',
      tip38: "In order to make the growth rate of downloads more believable, we will divide the promotion plan into three levels according to your app's installs.",
      tip39: 'Why your app need a lot of downloads?',
      tip40: 'You need enough downloads to make your app more searchable and increase your keyword coverage.',
      tip41: 'The more downloads and user engagement your app has, the better its rank position will be.',
      tip42: 'Reviews Goal Level',
      tip43: 'There is a strong positive correlation between reviews and installs, so we set the review goals to three levels just like the install goals.',
      tip44: 'Why your app need more positive reviews?',
      tip45: 'Many users rely on reviews and ratings of the app to choose which application to install. Thus, your app should target on having more positive reviews.',
      tip46: 'When the number of reviews reaches the specified level goal, the rates will tend to be stable and not easily modified.',
      tip47: 'Ratings Goal',
      tip48: 'Ratings are an important factor in keyword search rankings.',
      tip49: 'As for Google, it adds a rating filter to Google Play search results. It allows users to only see results that have a 4.0 or 4.5-star rating and above.The filter urges developers to improve their apps’ ratings to 4.0-start at least. Otherwise, they’ll lose a lot of chance for exposure.',
      tip50: 'That is why we set 5.0 as our ratings goal.',
      tip51: 'View in gp',
      tip52: 'Country',
      tip53: 'Refresh',
      tip54: 'Delete',
      tip55: 'Level',
      tip56: 'Goal',
      tip57: 'Delete All',
      tip58: 'Import',
      tip59: 'Please',
      tip60: 'for exclusive promotion plan.',
      tip61: 'Campaign',
      tip62: 'Record',
      tip63: 'Deposit',
      tip64: 'More +',
      tip65: 'ASOGrow User Guideline | Google Play ASO Platform',
      tip66: 'My Account',
      tip67: 'Lv1 Goal: ',
      tip68: 'Lv2 Goal: ',
      tip69: 'Tips:',
      tip70: 'Balance',
      tip71: 'Notification',
      tip72: 'Goal:5',
      tip73: ',',
      tip74: '.',
      tip75: 'OK',
    },
    myCampaign: {
      list1: 'Repeat',
      list2: 'Pause',
      list3: 'Cancel',
      list4: 'Consumption Cap',
      list5: 'Status',
      list6: 'Type',
      list7: 'Developer Name',
      list8: 'Campaign ID',
      list9: 'Package',
      list10: 'No Data',
      list11: 'Application',
      list12: 'Business Type',
      list13: 'Combo Package',
      list14: 'Promotion Time',
      list15: 'Amount',
      list155: 'Amount',
      list16: 'Consumption',
      list17: 'Data',
      list18: 'Promote',
      list19: 'Icon',
      list20: 'Service Type',
      list21: 'Total Cap',
      list22: 'Campaign Price',
      list23: 'Please Confirm the info of campaign.',
      list24: 'If confirm',
      list25: 'will be deducted from your account balance.',
      list26: 'you can deposit and start promotion immediately.',
      list27: 'Confirm',
      list28: 'Deposit with Stripe',
      list29: 'Payment successful. Campaign has been activated.',
      list30: 'View Campaign List',
      list31: 'The balance is not enough. Campaign cannot start.',
      list32: 'If you have any questions, please contact us.',
      list33: "Congratulations! You've got $5 trial bonus!",
      list34: 'You can now start a campaign to promote your app.',
      list35: 'Please contact us to get the bonus.',
      list36: "* We hope to provide you with the best service, please fill in the reason for canceling the campaign, we will continue to improve.",
      list37: 'Click here to promote your app',
      list38: 'Campaign Confirm',
      list39: 'The campaign will start at ',
      list40: 'after payment.',
      list41: 'This unit price of the order is discounted by',
      list42: 'Action',
      list43: 'Search',
      list44: 'Create Campaign',
      list45: 'Export',
      list46: 'Export Detail data',
      list47: 'Click to export the detailed data',
      list51: 'The unconsumed amounts will be returned to the balance after the promotion ends.',
      list52: 'If there is no data for more than a day, please contact us. Data may be delayed',
      list53: 'Close',
      list54: 'Save as Draft and Pay Later',
      list55: 'Start Promotion',
      list56: "You've got $5 trial bonus!",
      list57: "Notice:",
    },
    createCampaign:{
      create1: 'Direct Install',
      create2: 'Keyword Install',
      create3: 'Custom Reviews',
      create4: 'Guaranteed Reviews',
      create5: 'Likes&Dislikes',
      create6: 'Social Media',
      create7: 'Country/Region',
      create8: 'Choose one of your apps or ',
      create9: 'Select the country you want to promote.',
      create10: 'Please select country.',
      create11: 'Time Zone',
      create12: 'Select a time zone for daily cap updates.',
      create13: 'Time Schedule',
      create14: 'Select effective duration of the campaign.',
      create15: 'Creatives',
      create16: 'Image(.jpg, .png), up to 500 KB. Width * Height: 912 * 400.',
      create17: 'Search Keywords',
      create21: 'Daily Cap',
      create22: 'Please fill in an integer.',
      create23: 'Total Cap = Daily Cap * Promotion days.',
      create24: 'Order Price',
      create25: 'Unit Price',
      create26: 'Combo Details',
      create27: 'Installs and Open',
      create28: '5 Star Ratings',
      create29: 'Good Reviews',
      create30: 'Add one row',
      create31: 'Download,Open',
      create32: 'Basic Info',
      create33: 'Daily Cap = Custom Reviews/Promotion days',
      create34: `Total Cap can't be greater than the number of reviews.`,
      create344: 'Suggestion:Cap = Half of the number of reviews',
      create35: 'Learn about our offerwall App:',
      create37: "The Al will generate appropriate review content based on the following desired characteristics, combined with the app's Google Play description. Each review will notexceed 400 words.",
      create38: 'Language',
      create39: 'Category of APP',
      create40: 'The Tone Of Reviews',
      create41: 'Product Features',
      create42: 'You may enter multiple features, separated by ",/;". Three product features will be randomly selected for the review content',
      create45: 'Screenshot',
      create46: 'Media Platform',
      create47: 'Target',
      create48: 'Profile Name',
      create49: 'Profile Link',
      create50: 'Profile Avatar',
      create51: 'After confirm, the system will optimize your app according to the plan.',
      create53: 'The current country does not support this business type',
      create54: 'App',
      create55: 'add new app here',
      create56: 'Free trial is only available in Indonesia, India and the Philippines.',
      create57: 'Upload a file of comments',
      create58: 'Choose Creatives',
      create59: 'Download, Open',
      create60: 'Download, Open & Rating',
      create61: 'Download, Open & Rating & Review',
      create62: 'Keyword Install',
      create63: 'Search Keyword, Install and Open',
      create64: 'Custom Review',
      create65: 'Install, Open , Rating & Custom Review',
      create66: 'Keywords Install Rating',
      create67: 'Search Keyword, Install and Open & Rating',
      create68: 'Keywords Install Custom Reviews',
      create69: 'Search Keyword, Install and Open & Rating & Custom Review',
      create70: 'Rating',
      create71: 'Review',
      create72: 'Free trial is not available for Combo Package and Media.',
      create73: 'Total',
      create74: 'Combo package',
      create75: 'Quickly find the source of the campaign',
      create76: 'Add New App',
      create77: 'Promotion Days',
      create78: 'Campaign will start within 2 business days.',
      create79: 'Generated by AI',
      create80: 'Import Reviews',
      create81: 'Bulk Copy',
      create82: 'Please use the following document format: *.xls/*.txt/*.csv/*.xlsx',
      create83: 'Each review should not exceed 500 characters.Use ;/. separate each comment',
      create84: 'In addition to editing comments on the page, you can also import reviews according to the template style. ',
      create85: 'Click to ',
      create86: 'Download Template',
      create87: 'Confirm',
      create88: 'Duplicate comments and blank values are automatically removed, and comments will be added to existing comments after confirm.',
      create89: 'After depositing, return to this page to pay for and start the campaign.',
      create90: 'Review Keywords',
      create91: 'Keywords',
      create92: '1. Enter the words you want users to include in their reviews.',
      create93: '2. Each review keyword must not exceed 180 characters.',
      create94: '1. Please make sure your app ranks within 250 in this search keywords,otherwise users will not be able to search.',
      create95: "2. Don't add quotes, slashes, hashtags or special symbols.",
      create96: '3. Each search keywords should not exceed 20 characters.',
      create97: 'Add',
      create98: 'Only 20 keywords can be submitted at one time',
      create99: 'The number of custom reviews must be greater than or equal to the total number of promotion days.',
      create100: 'Keywords Install',
      create101: 'The maximum free cap is 5.',
      create102: 'Please fill in the user name of Google store reviewer.',
      create103: 'Please upload screenshots of review that need likes.',
      create104: 'Click to adjust images ',
      create105: 'that may affect advertising efficiency',
      create106: 'This website shall prevail',
      create107: 'Pricing Type',
      create108: 'Territories',
      create109: 'Back',
      create110: 'Campaign Detail',
      create111: 'Example',
      create112: 'A customizable campaign combining installs, ratings, and reviews.',
      create113: 'Drive organic growth with 100% real user installs.',
      create114: 'Boost keyword rankings and organic traffic through targeted installs.',
      create115: 'Increase your app rating to build user trust and encourage downloads.',
      create116: 'Gain positive user reviews to influence potential customers.',
      create117: 'Post tailored reviews to highlight your app\'s key features.',
      create118: 'Get custom reviews with a guaranteed duration of visibility on Google Play. No longevity, no charge.',
      create119: 'Increase likes on key reviews to boost their visibility and social proof.',
      create120: `We guide real users to leave authentic reviews for your app on Google Play, 
      ensuring they remain visible for over 3 days with a visibility guarantee. Our service focuses on enhancing app credibility through genuine feedback.`,
      create121: `This service increases the number of "helpful" or "like" votes on your app's positive reviews in app stores. By boosting engagement on high-quality reviews, 
      it enhances their visibility and credibility, influencing potential users' download decisions and improving your app's conversion rates through amplified social proof`,
      create122: `We boost your follower count across key platforms like TikTok, Facebook, X (formerly Twitter), and Google Maps by leveraging targeted strategies to attract real, 
      active users. Additionally, we drive authentic engagement by encouraging genuine likes on your priority content, enhancing visibility and credibility for sustainable growth`,
      create123: 'Ratings',
      create124: 'Reviews',
      create125: 'This service is not available in this country',
      create126: 'The minimum number of ratings per day is 5.',
      create127: 'The minimum number of installs per day is 10.',
      create128: 'The number of ratings must be less than or equal to the number of installs.',
      create129: 'Each keywords should not exceed 180 characters.',
      create130: 'Keywords in a single campaign should be different.',
      create131: `We recommend that the search keywords be a complete phrase, 
      for example: online shopping. If there are multiple phrases, it is recommended 
      that you click the Add button on the right to add them separately.`,
      create132: 'The password and confirmation do not match',
      create133: 'Minimum amount is 20$.',
      create134: 'The amount is too large, please re-enter.',
      create135: 'Please upload a file of comments',
      create136: 'Please select language.',
      create137: 'No more than 500K',
      create138: 'Please enter the password again',
      create139: 'Please select business type',
      create140: 'Please fill in the reason why you would like to cancel the campaign.',
      create141: 'Transaction ID cannot be empty.',
      create142: 'Transaction amount cannot be empty.',
      create143: 'Transaction Date cannot be empty.',
      create144: 'Amount is required.',
      create145: 'No more than ',
      create146: 'Good Review',
      create147: 'can\'t be empty.',
      create148: 'Please upload photos of jpg,png,and Width * Height: 1 * 1.',
      create149: 'up to 1 MB',
      create150: 'Width Height: 912 400',
      create151: 'Please upload photos of jpg,png,and ',
      create152: 'We noticed that you may have an Ad Blocker turned on and some errors may occur, we suggest you to turn it off.',
      create153: 'Add Success',
      create154: 'Successfully Registered!',
      create155: 'Success',
      create156: 'Error',
      create157: 'Refresh Success',
      create158: 'Delete Success',
      create159: 'Copy Success',
      create160: 'Copy Fail',
      create161: 'Start',
      create162: 'The promotion app is not selected,',
      create163: 'You can also add the target app on the homepage',
      create164: 'App is not found in store.',
      create165: 'Number of reviews:',
      create166: 'Video summary:',
      create167: 'Video summaries used for generating comments',
      create168: 'Additional requirements:',
      create169: 'Keywords that should be included in comments',
      create170: 'Further requests for comment content can be entered here',
      create171: 'Results:',
      create172: 'Feedback:',
      create173: 'Re-edit',
      create174: 'Order Instructions',
      create175: 'Due to specific reasons, we are currently unable to process online orders from US. We kindly inform you that for  the US region, a minimum order value of 1250 is required. To complete your order process, please contact us.',
      create176: 'Generate reviews by AI',
      create177: 'Maximum 100 at time',
      create178: 'no',
      create179: 'Ready to Launch',
      create180: 'Ready to promote in your region? Let’s help!',
      create181: 'Contact us for personalized support and a limited-time free trial to launch your campaigns.',
      create182: 'Click to contact',
      create183: 'Preview',
      create184: 'Generate',
      create185: 'Free Trial',
      create186: 'Media Type',
      create187: 'Instagram Post Banner',
      create188: 'Image(.jpg, .png), up to 500 KB. Width * Height: 1 * 1.',
      create189: 'Image(.jpg, .png), up to 1 MB.',
      create190: 'End',
      create191: 'Likes&Dislikes',
      create192: 'User Name',
      create193: 'Review helpfulness vote',
      create194: 'Your account balance is insufficient, You need another ',
      create195: '$',
      create196: '',
      create197: 'to start this campaign.',
      create198: 'Note',
      create199: 'This Campaign requires contacting the AM to pause and cancel',
      create200: 'Operation Successful',
      create201: 'Submitted Successfully',
      create202: 'Sent Successfully',
      create203: 'Saved Successfully',
    },
    profile: {
      profile1: 'Contact Details',
      profile2: 'Name for Invoice',
      profile3: 'Microsoft Teams',
      profile4: 'Address',
      profile5: 'Wechat',
      profile6: 'Telegram',
      profile7: 'WhatsApp',
      profile8: 'Change Password',
      profile9: 'Current Password',
      profile10: 'New Password',
      profile11: 'Re-enter Password',
      profile12: 'Save',
    },
    record: {
      record1: 'Stripe',
      record2: 'Payoneer',
      record3: 'Bank Transfer',
      record4: 'Cost',
      record5: 'Refund',
      record6: 'Free Bonus',
      record7: 'Bonus Cancel',
      record8: 'Manual Cost',
      record9: 'Paypal',
      record10: 'Advance Payment',
      record11: 'ID',
      record12: 'Create Time',
      record13: 'Detail',
      record14: 'Developer',
    },
    deposit: {
      deposit1: 'Add Money',
      deposit2: 'Single Recharge',
      deposit3: 'Bonus',
      deposit4: 'During the event, if you deposit $100, you will receive 100+8(8% bonus) = $108; if you deposit $1000, you will receive 1000+120=$1120.',
      deposit5: 'Please note:',
      deposit6: '1. This bonus is only issued to users who create ASO campaign.',
      deposit7: '2. ASOGrow reserves the right of final interpretation for the content and intems in above.',
      deposit8: 'For example, if you pay $500 - you will receive 500+25(5% bonus) = $525, or if you pay $1000 - you will receive 1000+100(10% bonus) = $1100,or if you pay $5000 - you will receive 5000+600(12% bonus) = $5600!',
      deposit9: '1. The 10% reward can only be used for advertising on the ASOGrow platform. If you apply for a refund, the amount of refund does not include the amount of bonus.',
      deposit10: '2. This bonus is only issued to users who create ASO campaign.',
      deposit11: '3. ASOGrow reserves the right of final interpretation for the content and intems in above.',
      deposit12: 'Recharge online and get bonus for your first online recharge! Pay $20 get $25. Pay $50 get $60 !',
      deposit13: '*If the original recharge amount has not been used up within 30 days, the bonus will be recalled. The original recharge amount will not be affected. Only valid for first recharge.',
      deposit14: 'Please choose a payment system to deposit',
      deposit15: 'Payment Amount:',
      deposit16: 'Totally Received:',
      deposit17: 'Deposit',
      deposit18: "Our platform DON'T collect or store any of your payment credentials.",
      deposit19: 'Bank Transfer',
      deposit20: 'We have received your messages.',
      deposit21: 'By submitting transfer information through the form,we can recharge you faster.', 
      deposit22: 'Transaction ID', 
      deposit23: 'Transaction Date', 
      deposit24: 'Transaction Amount', 
      deposit25: 'Account Name:', 
      deposit26: 'Bank Account:', 
      deposit27: 'Bank Name:', 
      deposit28: 'Bank Address:', 
      deposit29: 'SWIFT Code:', 
      deposit30: 'Bank Code:', 
      deposit31: 'Transfer Notes', 
      deposit32: 'Copy transfer information', 
      deposit33: 'My Payment', 
      deposit34: 'Update Time', 
      deposit42: 'Try again',
      deposit43: 'Submit',
      deposit44: '1. Minimum payment amount for this payment method is',
      deposit441: '',
      deposit45: '2. Please make sure that you fill in the',
      deposit46: 'according to the above requirements when transfering funds.',
      deposit47: '3. After payment, you can contact us through the following ways to speed up the payments.',
      deposit48: 'Remind',
      deposit49: 'Please finish the payment on the new page.',
      deposit50: 'The order is already submitted and being processed. Please wait for confirmation.',
      deposit51: 'Return to choose another method of payment',
      deposit52: 'Success',
      deposit53: 'You have depostied successfully and can start promotion.',
      deposit54: 'View my payment',
      deposit55: 'Create a campaign',
      deposit56: 'Failed',
      deposit57: 'Failed to recharge.',
      deposit58: 'From ',
      deposit59: 'if a single payment meets the following conditions, you can get extra bonus:',
      deposit60: 'PayPal Account',
      deposit61: 'Account Address',
      deposit62: 'Payoneer Account:',
      deposit63: 'Records per page',
      deposit64: 'Search for a keyword',
      deposit65: 'now on',
      deposit66: 'to',
    },
    price: {
      price2: 'We charge according to different business types and regions.',
      price3: 'Pay Service',
      price4: 'Each business type may contain one or more charging items, and we will charge for each charging item.The following is the price of each pay service.',
      price5: 'Service',
    },
    other: {
      other1: 'Terms:',
      other2: 'Please kindly note that the ratings and reviews have risk to be removed by Google Play which depends on the google rules and the status of your app.',
      other3: 'Usually, all ratings and reviews will be displayed on Google Play in 24 hours after your campaign is completed.',
      other4: "Some of your ratings and reviews may be removed by Google within 2-3 days, but before that it still helps you to boost your app's organic traffic.",
      other5: 'By continuing with ratings and reviews order you agree to take this risk. ',
      other6: 'Refund is not applicable when removal happens.',
      other7: 'For less removal',
      other8: 'please try to follow the rules below:',
      other9: 'Do not add tons of ratings and reviews for',
      other10: 'new apps',
      other11: 'or for apps with a small number of installs.',
      other12: 'Do not order more than 10-15% of total number of installs in ratings.',
      other13: 'Do not order more than 5% of total number of ratings in reviews.',
      other14: 'Do not add repeated reviews.',
      other15: 'Do not make too short reviews.',
      other16: "Ratings and reviews behavior should look like real user flow, proportionally to your app's organic traffic in the selected country and similar to your current number of ratings and reviews.  Google will remove some of ratings or reviews if they find them suspicious.",
      other17: 'Example #1: 100 installs + 5 ratings + 3 reviews is',
      other18: 'good.',
      other19: 'Example #2: 200 installs + 200 ratings to new app or app without any ratings is',
      other20: 'risky.',
      other21: '1.For less removal, we recommend extending the time schedule instead of doing all reviews in one day.',
      other22: 'For less removal, ratings should be less than 15% of installs.You can increase the number of installs.',
      other23: 'The number of reviews must be less than or equal to the number of ratings.',
      other24: "I've read and agree to the",
      other25: 'Terms',
      other26: 'Contact us to get discounts',
      other27: 'Sign Out',
      other28: 'Get more organic users',
      other29: 'Get more good reviews',
      other30: 'Improve your ratings',
      other31: 'Exit',
      other32: 'Please Select',
      other33: 'Write your comments of the generated results',
      other34: 'Select Media Type',
      other35: 'video',
      other36: 'Why cancel the campaign?',
      other37: 'The campaign will start within two days.',
      other38: 'The campaign will start immediately after payment.',
      other39: 'Boost Your App\'s Visibility in Google Play Store with',
      other40: 'ASO',
      other41: 'Grow',
      other42: 'Direct installs for Android',
      other43: 'Keyword Search Optimization',
      other44: 'Ratings & Reviews Optimization',
      other45: 'Likes to review',
      other46: 'Contact us, you will get:',
      other47: '1. Professional ASO Service',
      other48: '2. Customized optimization plan for your APP',
      other49: '3. Surprising trial bonus',
      other50: 'The number of ',
      other51: ' cannot exceed ',
      other52: 'custom reviews',
      other53: 'good reviews',
      other54: 'Select',
      other55: 'amount',
      other56: 'No data for last 15 days',
      other57: '* The data will only be recorded when the promotion campaign is started, ',
      other58: 'click here',
      other59: 'to create your campaigns',
      other60: 'Click the legend below to switch',
      other61: 'installs',
      reviews: 'reviews',
      ratings: 'ratings',
      attitude: 'Positive,Satisfied,Sincere,Enthusiastic,Praising',
      other62: 'bonus',
      other63: 'to',
      'Download,Open': 'Download,Open',
      'Rating': 'Rating',
      'Custom Review': 'Custom Review',
      'Search Keyword,Install and Open': 'Search Keyword,Install and Open',
      'Review': 'Review',
      'Likes to Review': 'Likes to Review',
      'Instagram Follow': 'Instagram Follow',
      'Instagram Post Like': 'Instagram Post Like',
      'Youtube Subscribe': 'Youtube Subscribe',
      'Youtube Comment': 'Youtube Comment',
    },
    menu: {
      menu1: 'Grow My Apps',
      menu2: 'Campaign',
      menu3: 'Create Campaign',
      menu4: 'My Campaign',
      menu5: 'Deposit',
      menu6: 'Record',
      menu7: 'Account',
      menu8: 'FAQ',
      menu9: 'Support',
      menu10: 'Top-ranking Task',
      menu11: 'My Top-ranking Task',
    },
    guide:{
      guide1: 'Click the plus button and paste your app\'s store url to get promotion plan for your app.',
      guide2: 'Check Out Your App\'s Promotion Plan',
      guide3: 'Choose what you want to improve.',
      guide4: 'Create First Campaign For Free',
      guide5: 'It only takes 1 minute to create your campaign, easy and fast.',
      guide6: 'Check Out Statistics',
      guide7: 'Track data changes, output data analysis, and help promote your App.',
      guide8: 'Last But Not Least',
      guide9: 'Don\'t miss our recharge bonus.',
      guide10: 'NEW',
    },
    support: {
      support1: '1.How your app gets organic users with ASOGrow Platform?',
      support2: `We are here to help your app grow organic downloads at an affordable cost.
      - By placing advertisements on our platform, your application can directly reach 100% real users without any third party, making your application safer and more effective.
      - We guarantee that all installs, ratings and reviews are from real users and are fully valid. Absolutely safe for your application.`,
      support4: '2.Where will your ad appear?',
      support5: 'Your campaign will be placed in our offerwall App, JadiDuit. Learn about or install JadiDuit App: https://jadiduit.id/',
      support6: '3.What is Keyword Search Campaign?',
      support7: `In a keyword search campaign, users will search Google Play using a specified target keyword, find your app in the search results, and install it. 
      So the focus of this promotion is to allow more natural users to search for your app when they search for target keywords.`,
      support8: '4.What is App Rank for Keyword?',
      support9: 'Ranking shows your app\'s position in app listings when a user looks for a specific keyword on Google Play or the AppStore. Both Google Play and the AppStore show 250 apps in the app listings when a user looks up a keyword in the market.',
      support10: '5.What is Ratings and Reviews Campaign?',
      support11: `In Ratings and Reviews ads, users will rate and review your app in the Google Play Store. Good reviews can attract more users for you.
      Note: If users don\'t like your app or feel it\'s not safe to keep it, they may uninstall it and give it a bad review. Only positive reviews count as conversions.`,
      support12: '6.How do we calculate the price?',
      support13: `Each item is charged separately. The price of each item varies by country.
      Install and open, search for keywords, install and open, likes and comments are all independent projects.
      The price of "install, open and rate" is equal to install + rate; the price of "install, open, rate and review" is equal to install + rate + review`,
      support14: '7.Can I delete or pause incomplete campaign?',
      support15: `Sure, you can pause unfinished campaigns yourself.
      Locate the campaign and click 【Pause】.
      Note: It takes a few minutes to suspend your campaign, and any installs made during this time will be charged until your campaign ends successfully.`,
      support16: '8.Can I change my setting after the campaign is created?',
      support17: 'No, you cannot edit your campaigns when the campaign is running. But you can pause the campaign and create a new one.',
      support18: '9.When will your campaign be automatically paused by the system?',
      support19: `1. Higher risk of fraud detection.
      2. The conversion rate is too low, which indicates some technical issues with your app or tracking.`,
      support20: '10.When the downloads amount will be showed in the Google Play?',
      support21: 'Note that this may take up to 24 - 36 hours (sometimes even longer due to Google Play\'s own algorithm).',
      support22: '11.When will the campaign start?',
      support23: 'You need to set the start time of the campaign yourself, when the campaign is active and the start time is reached, your campaign will run automatically.',
      support24: '12.How can I get the refund?',
      support25: `For a refund, you can contact us by email, Teams or WhatsApp and tell us the reason for the refund.
      Please note that we can only refund funds from your main balance, we will not refund funds from bonus balances.`,
      support26: '13.What should I do if I don\'t see the installs?',
      support27: `If you checked your installs in Google Developer and not all installs are reflected, please make sure the order was placed 2-3 days ago, as it usually takes this time for the app store to reflect the installs in the stats.
      If your installation has not been reflected 2-3 days after the order was completed, please feel free to contact us via any convenient communication tool. They will explain why and help resolve the issue.`,
      support28: '14.Can you promote paid apps?',
      support29: 'Sorry for the inconvenience, we can only promote free apps published on Google Play at this time.',
      support30: 'How to calculate the price',
      support31: 'We charge according to different business types and regions.',
      support32: 'Note',
      support33: 'Yes',
      support34: 'No',
      support35: 'Generating reviews, please wait patiently...',
      support36: 'AI failed to generate long reviews. Please retry or reduce the number of reviews to lower failure rate.',
      support37: '$',
      support38: '',
      support39: '',
      support40: '',
    },
    noknow:{
      noknow1: 'Reviews with Emoji:',
    },
    createCampaignBrush: {
      typeIndustryListRanking: 'Industry list Ranking',
      typeGuaranteedKeywordRanking: 'Guaranteed Keyword Ranking',
      os: 'OS',
      googlePlay: 'Google Play',
      appStoreIPhone: 'App Store on IPhone',
      appStoreIPad: 'App Store on IPAD',
      ranking: 'Ranking',
      top1: 'Top1',
      top2: 'Top2',
      top3: 'Top3',
      top1To3: 'Top1-3',
      top4To6: 'Top4-6',
      top7To12: 'Top7-12',
      top13To25: 'Top13-25',
      top26To35: 'Top26-35',
      top36To50: 'Top36-50',
      promoteDays: 'Promote days',
      weeks2: '2 weeks',
      weeks3: '3 weeks',
      more: 'More',
      cap: 'Cap',
      contact: 'Contact',
      teams: 'Teams',
      brush1: '1.Ensure your app ranks within the top 250 for these search keywords; otherwise, users will not be able to find your app.',
      brush2: '2.Use quotation marks, forward slashes, hash symbols, or special characters to distinguish keywords.',
      brush3: 'Please fill in your contact information correctly. The task can only begin after communication.',
      brush4: 'After placing the order, please keep the contact information smooth, convenient communication delivery effect',
      brush5: 'This is Advance Payment. Actual orders will be subject to communicate.',
      brush6: 'Advance Payment',
      brush7: 'This is an advance payment.',
      brush8: 'Your final order requirements and schedule will be customized according to the agreement between us.Order prices retreat more fill less.',
      appleLinkErr: 'The link format is incorrect',
      contentTip1:'Boost keyword rankings and organic traffic through targeted installs.',
      contentInfo1:'The installs generated by this service are not from real users. As such, the engagement quality, user behavior patterns, and long-term stability of the ranking improvements may differ from those achieved through organic user acquisition or campaigns driven by genuine user interest. We recommend this primarily as a tactical supplement within a broader, comprehensive marketing strategy.',
      contentTip2:'An ASO strategy to climb category-specific leaderboards (e.g., "Finance") for increased visibility and organic downloads.',
      contentInfo2:`This ASO service helps an app achieve a specified position on a specific category's leaderboard (e.g.,"Finance") within app stores to significantly increase visibility and drive substantial organic downloads . Providers typically employ strategies focused on generating a high volume of quality downloads in a short period, a key factor influencing the ranking algorithm for these charts . This approach is particularly effective for new app launches, major updates, or targeted campaigns in specific regions or sub-categories`,
      contentTip3:'A performance-based ASO service that ensures your app reaches a specific rank for chosen keywords, backed by a refund policy.',
      contentInfo3:"A professional App Store Optimization (ASO) service that guarantees your app reaches and maintains a specified rank (e.g., Top 3) for a target keyword in the official store's search results. It is effect-based with clear KPI and refund terms. The provider manually optimizes the app's metadata and adapts to algorithm changes to sustain the position, ideal for mature apps to capture high-value traffic.",
    },
  },
}